export const env = {
  appTitle: import.meta.env.VITE_APP_TITLE,
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  enableDevtools: import.meta.env.VITE_ENABLE_DEVTOOLS === 'true',
  logLevel: import.meta.env.VITE_LOG_LEVEL || 'info',
  sentryDsn: import.meta.env.VITE_SENTRY_DSN,
  recaptchaSiteKey: import.meta.env.VITE_RECAPTCHA_SITE_KEY,
  appUserSecretKey: import.meta.env.VITE_APP_USER_SECRET_KEY,
  accessTokenSecretKey: import.meta.env.VITE_ACCESS_TOKEN_SECRET_KEY,
  pendingLoginSecretKey: import.meta.env.VITE_ACCESS_TOKEN_SECRET_KEY,
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const

export type Env = typeof env
